function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import * as actions from '../../actions';
import { DOWNLOADER_STATUSES } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../../components/DownloadDataModal/DownloadDataModal.pcss';
const Initializing = ({ onInitialized, onSetComponent })=>{
    const downloader = useSelector(selectors.downloader);
    const status = useSelector(selectors.status);
    const isInProgress = useSelector(selectors.isCheckDownloaderInProgress);
    const prevIsInProgressRef = useRef(isInProgress);
    const checkStatus = useAction(actions.checkStatus);
    const checkBlueCableDriver = useAction(actions.checkBlueCableDriver);
    useEffect(()=>{
        checkStatus();
        checkBlueCableDriver();
    }, []);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress) {
                if (status === DOWNLOADER_STATUSES.READY) {
                    onInitialized();
                    return;
                }
                if (downloader.mdaVersion) {
                    onSetComponent('NoConnection');
                } else {
                    onSetComponent('InstallDownloader');
                }
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.initializing.header))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/loader.svg",
                    className: "rotatingLoader",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info text--center mb-5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.initializing.waiting))
            })
        ]
    });
};
export default Initializing;
